import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {router} from 'lit-element-router';
import {msg} from '@lit/localize';
import store from '../store';

import getRoutes from '../routes';
import {setLang} from '../slices/statusSlice';

@customElement('language-switch')
export class LanguageSwitch extends connect(store)(router(LitElement)) {

	static styles = [
		css`
			:host {
				margin-right: var(--padding);
				display: flex;
			}

			.languages {
				color: var(--color-white);
			}

			.label {
				color: var(--color-grey3);
				display: block;
				padding-bottom: var(--very-small-padding);
			}
			.language {
				cursor: pointer;
				display: inline-block;
				padding-right: var(--small-padding);
				color: var(--color-grey4);
				text-transform: uppercase;
			}
			.active {
				color: var(--color-white);
			}

        `
	];

	@property({type: Object})
	params = {};

	static get routes() {
		return getRoutes();
	}

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	router(route, params, query, data) {
		this.params = params;
	}
	stateChanged(state) {
		this.dashboardActive = state.status.dashboardActive;
		this.specsheetActive = state.status.specsheetActive;
		this.lang = state.status.lang;
		this.embed = state.status.embed;
	}
	setLanguage(language) {
		store.dispatch(setLang({lang: language}));
	}

	render() {
		return html`
			<div class="languages">
				${when(this.embed,
					() => html`
						<a class="language ${classMap({active: this.lang === 'de'})}" @click="${() => this.setLanguage('de')}" }>de</a>
						<a class="language ${classMap({active: this.lang === 'en'})}" @click="${() => this.setLanguage('en')}" }>en</a>
						<a class="language ${classMap({active: this.lang === 'fr'})}" @click="${() => this.setLanguage('fr')}" }>fr</a>
					`,
					() => html`
						<router-link .active=${this.params.language === 'de'} class="language" .params=${{language: 'de'}}>de</router-link>
						<router-link .active=${this.params.language === 'en'} class="language" .params=${{language: 'en'}}>en</router-link>
						<router-link .active=${this.params.language === 'fr'} class="language" .params=${{language: 'fr'}}>fr</router-link>
					`)}
			</div>
		`;
	}
}
